import React, {useState, useEffect} from 'react';
import {useSelector, shallowEqual} from 'react-redux';

import {logPageLoadEvents} from '@ibibo/analytics';

import * as S from './RoomSelection.styles';

import Filter from './Filter';
import Rooms from './Rooms';

import {
  roomsDataHermes as roomsDataHermesSelectorFn,
  appliedFiltersSelector,
  roomsFilterDataSelector,
} from '../../selectors';

import {RfElementType} from '../../redux/types';

import getFilteredRooms from '../../utils/get-filtered-rooms';

const RoomSelection = ({searchType}) => {
  const roomsDataFromHermes = useSelector(roomsDataHermesSelectorFn, shallowEqual);

  const appliedFiltersCodes = useSelector(appliedFiltersSelector);
  const roomsFilterData = useSelector(roomsFilterDataSelector);

  const appliedFilters = React.useMemo(() => {
    return roomsFilterData.filter(roomFilterData =>
      appliedFiltersCodes.includes(roomFilterData?.fc),
    );
  }, [appliedFiltersCodes, roomsFilterData]);

  const [currentFilters, setFilters] = useState<RfElementType[] | Array<any>>(
    appliedFilters.length > 0 ? appliedFilters : [],
  );

  useEffect(() => {
    if (appliedFilters.length > 0) {
      setFilters(appliedFilters);
    }
  }, [appliedFilters]);

  useEffect(() => {
    logPageLoadEvents(`funnel:${searchType} hotels:rooms selection`, {});
  }, []);

  const filteredRooms = getFilteredRooms({currentFilters, roomsDataFromHermes});

  return (
    <S.DetailRoomInfoOuterWrap>
      <Filter setFilters={setFilters} currentFilters={currentFilters} />
      <Rooms rooms={filteredRooms} roomsFromHermes={roomsDataFromHermes} />
    </S.DetailRoomInfoOuterWrap>
  );
};

export default RoomSelection;
